import { z } from "zod";

export const RootFactNodeContentSchema = z.object({
  nodeType: z.literal("root"),
  version: z.literal("1"),
});

export const RootConnectsWithFactEdgeMetadataSchema = z.object({
  edgeType: z.literal("connectsWith"),
  version: z.literal("1"),
  relationship: z
    .string()
    .max(128)
    .optional()
    .describe(
      "The nature of connection (e.g. company, contractor, lead, partner, ...)",
    ),
});
